// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB9sE382UfH-n_Ha_2FqCxU_aGmV8DHovk",
  authDomain: "nmnbh-e9b24.firebaseapp.com",
  databaseURL: "https://nmnbh-e9b24-default-rtdb.firebaseio.com",
  projectId: "nmnbh-e9b24",
  storageBucket: "nmnbh-e9b24.firebasestorage.app",
  messagingSenderId: "772245347195",
  appId: "1:772245347195:web:28a299c25e94734c13bbde",
  measurementId: "G-5JLGCLSLDG"
};









// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export { app };